// extracted by mini-css-extract-plugin
module.exports = {"banner":"BannerCustom_banner__MKs8W"};